module.exports = __webpack_public_path__ + "media/flags/mk-0811b040.svg";